import {
  Check,
  ChevronDown,
  CircleDot,
  Database,
  FileSearch,
  MessageSquareText,
  ShieldCheck,
} from "lucide-react"
import type { TimelineEvent } from "@resolto/domain"
import { formatRelativeDate } from "@/lib/format"

const eventIcons = {
  employee_report: MessageSquareText,
  clarification_question: MessageSquareText,
  employee_answer: MessageSquareText,
  playbook_selected: FileSearch,
  connector_check: Database,
  evidence_received: Database,
  finding_created: CircleDot,
  approval_requested: ShieldCheck,
  approval_response: ShieldCheck,
  action_result: Check,
  escalation_created: FileSearch,
  developer_confirmation: Check,
  code_proposal_created: FileSearch,
  case_resolved: Check,
}

export function EvidenceTimeline({ events }: { events: TimelineEvent[] }) {
  return (
    <ol className="case-timeline">
      {events.map((event) => {
        const Icon = eventIcons[event.type]
        return (
          <li
            key={event.id}
            id={event.evidenceIds?.[0] ? `timeline-${event.evidenceIds[0]}` : undefined}
          >
            <span className={`case-timeline-icon state-${event.status}`}>
              <Icon aria-hidden="true" />
            </span>
            <div className="timeline-content">
              <div className="timeline-heading">
                <div>
                  <strong>{event.title}</strong>
                  <span>
                    {event.actor} · {formatRelativeDate(event.timestamp)}
                  </span>
                </div>
                <span className={`timeline-state timeline-state-${event.status}`}>
                  {event.status}
                </span>
              </div>
              <p>{event.description}</p>
              {(event.technicalDetail || event.evidenceIds?.length) && (
                <details className="timeline-details">
                  <summary>
                    Technical detail
                    <ChevronDown aria-hidden="true" />
                  </summary>
                  {event.technicalDetail && <p>{event.technicalDetail}</p>}
                  {event.evidenceIds?.length ? (
                    <span>Evidence: {event.evidenceIds.join(", ")}</span>
                  ) : null}
                </details>
              )}
            </div>
          </li>
        )
      })}
    </ol>
  )
}
